import { createPinia } from 'pinia'

/**
 * Using a store outside a component
 * https://pinia.vuejs.org/core-concepts/outside-component-usage.html
 */
export const pinia = createPinia()
